module.exports = "<router-outlet></router-outlet> <image-zoom></image-zoom>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main